/*eslint-disable */
import {
  mapGetters
} from 'vuex';
import {
  bus
} from '@/main';
import toast from '@/services/toast';
export default {
  name: 'cancel-membership-popup',
  components: {},
  props: [],
  data () {
    return {
      reason:'',
      selfUserInfo:null,
      submitted:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
  },
  mounted () {
    this.chatRequestDetails = this.memberUserInfo
    this.getUserDetailsAgainFun
  },
  methods: {
    cancelMembershipConfirm() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              user_id:this.selfUserInfo.id,
              subscription_id:this.selfUserInfo.subscription_id,
              reason:this.reason,
            }
            this.$store.dispatch('userCancelSubscriptionFunc', data)
              .then((res) => {
                  toast.success('Subscription Cancelled Successfully');
                  this.$store.dispatch('getAcUserDetailsFun')
                  this.cancelMembershipPopupClose()
              }).catch((error) => {
                  toast.error(error.data.msg);
                  this.cancelMembershipPopupClose()
              })
            return;
        }
      });
    },
    cancelMembershipPopupClose(){
      bus.$emit('cancelMembershipPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  },
  watch:{
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters
    },
  }
}